import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import SettingEdit from '@/views/setting/Edit.vue';

export const settingEditRoute: RouteConfig = {
  path: 'edit/:settingId',
  name: 'settingEdit',
  component: SettingEdit,
  props: {
    edit: true
  },
  meta: {
    breadcrumb: {
      title: 'breadcrumbs.settings.edit'
    }
  },
  beforeEnter: (to, from, next) => {
    store.commit('setting/setId', tryParseInt(to.params.settingId));
    Promise.all([
      store.dispatch('setting/get').then(setting => (settingEditRoute.meta.breadcrumb.title = setting.code)),
      store.dispatch('setting/group/list', { count: -1 })
    ])
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.setting.getError' }));
  }
};
